import axios from "../utils/axios";

export const getUserGroups = () => {
    return axios.get(`/UserGroup/GetUserGroups`);
};

export const addUserGroup = (payload) => {
    return axios.post(`/UserGroup/Add`, payload);
};

export const updateUserGroup = (payload) => {
    return axios.post(`/UserGroup/Update`, payload);
};

export const deleteUserGroup = (payload) => {
    return axios.post(`/UserGroup/Delete`, payload);
};

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getUserGroupbyid = (id) => {
    return axios.get(`/UserGroup/GetUserGroupsById`, { params: { id: id } });
};

export const getPoolList = () => {
    return axios.get(`/Pool/GetList`);
};

export const updatePoolofUserGroup = (payload) => {
    return axios.post("/UserGroup/UpdatePoolsOfUserGroup?userGroupId=" + payload.id, payload.data);
};
